
import { auth } from "./config";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail
} from "firebase/auth";
import { db } from "./config";
import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp
} from "firebase/firestore";

// ==========================================
// 🔍 FULL DEBUG LOGIN TEST
// ==========================================
export const debugLogin = async (email, password) => {
  const logs = [];

  // ========== TEST 1: Firebase Config ==========
  logs.push({ step: 1, test: "Firebase Config", status: "info", message: `Project: ${auth.app.options.projectId}` });
  logs.push({ step: 1, test: "Firebase Auth", status: "info", message: `Auth available: ${!!auth}` });
  logs.push({ step: 1, test: "Firebase DB", status: "info", message: `DB available: ${!!db}` });

  // ========== TEST 2: Auth Sign-In ==========
  try {
    logs.push({ step: 2, test: "Firebase Auth Sign-In", status: "testing", message: `Trying: ${email}` });
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    logs.push({ step: 2, test: "Firebase Auth Sign-In", status: "success", message: `✅ SUCCESS! UID: ${user.uid}` });
    logs.push({ step: 2, test: "User Email", status: "info", message: `Email: ${user.email}` });
    logs.push({ step: 2, test: "Display Name", status: "info", message: `Name: ${user.displayName || "(empty)"}` });

    // ========== TEST 3: Firestore Document ==========
    try {
      logs.push({ step: 3, test: "Firestore Read", status: "testing", message: `Reading /users/${user.uid}` });
      const userDoc = await getDoc(doc(db, "users", user.uid));

      if (userDoc.exists()) {
        const data = userDoc.data();
        logs.push({ step: 3, test: "Firestore Document", status: "success", message: `✅ FOUND: ${JSON.stringify(data, null, 2)}` });

        // Check if role exists
        if (!data.role) {
          logs.push({ step: 3, test: "Role Field", status: "warning", message: "⚠️ 'role' field missing! Adding..." });
          await setDoc(doc(db, "users", user.uid), { role: "sales" }, { merge: true });
          logs.push({ step: 3, test: "Role Field", status: "success", message: "✅ Role added: sales" });
        }

        // Check if password exists
        if (!data.password) {
          logs.push({ step: 3, test: "Password Field", status: "warning", message: `⚠️ 'password' field missing. Adding: ${password}` });
          await setDoc(doc(db, "users", user.uid), { password: password }, { merge: true });
          logs.push({ step: 3, test: "Password Field", status: "success", message: "✅ Password added" });
        }

        // Check if isActive exists
        if (data.isActive === undefined) {
          logs.push({ step: 3, test: "IsActive Field", status: "warning", message: "⚠️ 'isActive' missing! Adding true..." });
          await setDoc(doc(db, "users", user.uid), { isActive: true }, { merge: true });
          logs.push({ step: 3, test: "IsActive Field", status: "success", message: "✅ isActive added: true" });
        }

        return {
          success: true,
          logs,
          user: {
            uid: user.uid,
            email: user.email,
            ...data
          }
        };
      } else {
        logs.push({ step: 3, test: "Firestore Document", status: "warning", message: "⚠️ Document MISSING! Auto-creating..." });

        const newDoc = {
          name: user.displayName || user.email.split("@")[0],
          email: user.email,
          password: password,
          role: "sales",
          phone: "",
          isActive: true,
          joinedAt: serverTimestamp()
        };

        await setDoc(doc(db, "users", user.uid), newDoc);
        logs.push({ step: 3, test: "Auto-Create Document", status: "success", message: `✅ Document created: ${JSON.stringify(newDoc)}` });

        return {
          success: true,
          logs,
          user: {
            uid: user.uid,
            email: user.email,
            ...newDoc
          }
        };
      }
    } catch (firestoreError) {
      logs.push({
        step: 3,
        test: "Firestore Access",
        status: "error",
        message: `❌ ERROR: ${firestoreError.message}`
      });

      logs.push({
        step: 3,
        test: "SOLUTION",
        status: "info",
        message: "👉 Firebase Console → Firestore → Rules → Paste this:"
      });
      logs.push({
        step: 3,
        test: "RULES",
        status: "info",
        message: `rules_version = '2';
service cloud.firestore {
  match /databases/{database}/documents {
    match /{collection}/{doc} {
      allow read, write: if request.auth != null;
    }
  }
}`
      });

      return {
        success: true,
        logs,
        user: {
          uid: user.uid,
          email: user.email,
          name: user.email.split("@")[0],
          role: "sales"
        }
      };
    }

  } catch (authError) {
    logs.push({
      step: 2,
      test: "Firebase Auth Sign-In",
      status: "error",
      message: `❌ ${authError.code}: ${authError.message}`
    });

    // Common fixes
    if (authError.code === "auth/operation-not-allowed") {
      logs.push({
        step: 2,
        test: "SOLUTION",
        status: "info",
        message: "👉 Firebase Console → Authentication → Sign-in method → Email/Password → ENABLE → Save"
      });
    }
    if (authError.code === "auth/user-not-found") {
      logs.push({
        step: 2,
        test: "SOLUTION",
        status: "info",
        message: `👉 Firebase Console → Authentication → Users → Add user → Email: ${email}, Password: ${password}`
      });
    }
    if (authError.code === "auth/invalid-credential" || authError.code === "auth/wrong-password") {
      logs.push({
        step: 2,
        test: "SOLUTION",
        status: "info",
        message: "👉 Password galat hai! Firebase Console → Authentication → Users → Check password"
      });
    }
    if (authError.code === "auth/network-request-failed") {
      logs.push({
        step: 2,
        test: "SOLUTION",
        status: "info",
        message: "👉 Internet connection check karo!"
      });
    }

    return {
      success: false,
      logs,
      user: null
    };
  }
};